import styled from 'styled-components';

export const CompanyPageContainer = styled.div`
  display: block;
  height: 100%;
  width: 100%;
`;

export const CompanyPageContent = styled.div`
  display: block;
  height: 100%;
  width: 100%;
  text-align: center;
  img {
    width: 100%;
    max-width: 1000px;
  }
`;

export const TopPanel = styled.div`
  height: 100%;
  font-weight: bold;
  color: var(--logo-orange);
  font-size: 20px;
  padding: 10px;
  line-height: 40px;
`;

export const BottomPanel = styled.div`
  display: inline-block;
  height: 100%;
  padding: 10px;
  line-height: 25px;
  text-align: justify;
  .right {
    text-align: right;
  }
`;

export const TimelineContainer = styled.div`
  display: inline-block;
  height: 100%;
  padding: 0 30px;
  text-align: justify;
`;

export const CompanyInfoTable = styled.div`
  display: inline-block;
  height: 100%;
  width: 100%;
  text-align: center;
  margin: 10px auto;
  table {
    margin: 0 auto;
    border-collapse: collapse;
    width: 100%;
    max-width: 1000px;
  }
  td {
    border: solid 1px black;
    padding: 10px;
    width: auto;
  }
  td.head {
    width: auto;
  }
`;